interface RangeArgs {
	/**
	 * Start of the array. Inclusive.
	 */
	from: number;

	/**
	 * End of the array. Inclusive.
	 */
	to: number;

	/**
	 * Difference between elements of the array.
	 *
	 * @default 1
	 */
	step?: number;
}

export function range({ from, to, step = 1 }: RangeArgs): number[] {
	const x: number[] = [];

	for (let i = from; i <= to; i += step) {
		x.push(i);
	}

	return x;
}
